import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ensureDecorativeFontsLoaded } from 'src/utils/loadDecorativeFonts'
import {
  PCWTCContainer,
  PCWTCImage,
  PCWTCPlanContainer,
  PCWTCPremadePlanText
} from './planCardWithTypeChoiceStyles'

export const PlanCardWithTypeChoice = ({ cards = [] }) => {
  useEffect(() => {
    ensureDecorativeFontsLoaded()
  }, [])

  return (
    <PCWTCContainer>
      {cards?.map((item, index) => (
        <PlanCardWithTypeSinglePremadeItem
          key={index}
          type={item.type}
          textOne={item?.data?.textOne}
          textTwo={item?.data?.textTwo}
          textThree={item?.data?.textThree}
          image={item?.data?.image}
          linkPathname={item?.data?.linkPathname || '/'}
        />
      ))}
    </PCWTCContainer>
  )
}

const PlanCardWithTypeSinglePremadeItem = ({
  type,
  textOne,
  textTwo,
  textThree,
  image,
  linkPathname,
}) => {
  let color = ''
  switch (type) {
    case 'premade':
      color = '#cbd3ff'
      break
    case 'therapist':
      color = '#f1dddd'
      break
    case 'psychiatry':
      color = '#f2fbcc'
      break
    default:
      color = '#f2fbcc'
  }

  return (
    <PCWTCPlanContainer as={Link} to={linkPathname} style={{ background: color }}>
      {type === 'therapist' && <ImagesComponent />}
      {image && <PCWTCImage src={image} />}
      <PCWTCPremadePlanText dark bolder>
        {textOne}
      </PCWTCPremadePlanText>
      <PCWTCPremadePlanText bolder>{textTwo}</PCWTCPremadePlanText>
      <PCWTCPremadePlanText dark specialFont bolder>
        {textThree}
      </PCWTCPremadePlanText>
    </PCWTCPlanContainer>
  )
}

const ImagesComponent = () => {
  return (
    <div style={{ display: 'flex', marginBottom: '15px' }}>
      <img
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          border: '1px solid #495064',
          position: 'relative',
          left: '5px',
        }}
        src="https://media.aumhum.com/images/prod/MEDIA-0fcf39ef475749fabb143c8d191d82fe"
        alt="therapistImage"
      />
      <img
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          border: '1px solid #495064',
          zIndex: 1,
        }}
        src="https://media.aumhum.com/images/prod/MEDIA-4aa7d3018def4134aab597cb0e0e3d88"
        alt="therapistImage"
      />
      <img
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          border: '1px solid #495064',
          position: 'relative',
          right: '5px',
        }}
        src="https://media.aumhum.com/images/prod/MEDIA-65a380a22b3143c99e438b809b4ab7e5"
        alt="therapistImage"
      />
    </div>
  )
}
